// extracted by css-extract-rspack-plugin
export default {"comment":"CandidateComment_comment__6w+as","repliesWrapper":"CandidateComment_repliesWrapper__sftyB","replyLoaderWrapper":"CandidateComment_replyLoaderWrapper__jMuX1"};